import { Button } from "components/ui/button";
import { useIntercom } from "react-use-intercom";

interface SupportButtonProps {
  text?: string;
  variant?: React.ComponentProps<typeof Button>["variant"];
  className?: string;
}

const SupportButton = (props: SupportButtonProps) => {
  const { show } = useIntercom();

  return (
    <Button
      variant={props.variant ?? "ghost"}
      className={props.className}
      onClick={() => show()}
    >
      {props.text ?? "Contact Us"}
    </Button>
  );
};

export { SupportButton };
